import { Grid, NumberInput, TextInput } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import { IconBarcode, IconInfoCircle, IconTaxPound } from '@tabler/icons-react';
import type { UseMutationResult } from 'react-query';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import type { ApiResponse } from '../../../util/types/Response';
import { useServerBarcodeValidation } from '../hooks/useServerBarcodeValidation';

type UpsertBarcodeFormProps = {
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	form: UseFormReturnType<any, (values: any) => any>;
	mutation: UseMutationResult<ApiResponse<any>, unknown, void, unknown>;
};

export function UpsertBarcodeForm({ form, mutation }: UpsertBarcodeFormProps) {
	useServerBarcodeValidation(mutation, form);

	return (
		<>
			<Grid>
				<Grid.Col span={8}>
					<TextInput
						label={'Barcode'}
						placeholder={'Insert new barcode...'}
						leftSection={<IconBarcode {...defaultIconStyle} />}
						key={form.key('barcode')}
						{...form.getInputProps('barcode')}
					/>
				</Grid.Col>
				<Grid.Col span={4}>
					<NumberInput
						label={'Price Inc. VAT'}
						placeholder={'Insert price including VAT...'}
						key={form.key('price')}
						{...form.getInputProps('price')}
						decimalScale={2}
						prefix="£"
						leftSection={<IconTaxPound {...defaultIconStyle} />}
						allowNegative={false}
						thousandSeparator={','}
					/>
				</Grid.Col>
				<Grid.Col span={12}>
					<TextInput
						label={'Description'}
						placeholder={'Insert description of new product...'}
						leftSection={<IconInfoCircle {...defaultIconStyle} />}
						key={form.key('description')}
						{...form.getInputProps('description')}
					/>
				</Grid.Col>
			</Grid>
		</>
	);
}
